module.exports = __webpack_public_path__ + "static/media/a-2-d.32b62eea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-2-d.jpg
// module id = 1095
// module chunks = 33